module.exports = __webpack_public_path__ + "static/vtgym-website-video-preview-c13125d127f8993f38b4967bc74bd8d5.mp4";